import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'

/** 방문자 국가 (`GET /geo`). 표시 통화를 고르는 데만 쓴다 — utils/DisplayCurrency */
export const getGeo = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/geo'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const geoApi = {
	getGeo: getGeo,
}

export default geoApi
